const hasSegment = Boolean(window.analytics)

if (!hasSegment) {
  console.log('Segment not set up.')
}

export function identify (userId, traits) {
  if (!hasSegment) return

  window.analytics.identify(userId, traits)
}

export function logPlayTrack (artist, title) {
  if (!hasSegment) return

  window.analytics.track('Artist played', {
    label: artist
  })
  window.analytics.track('Track played', {
    label: `${artist} - ${title}`
  })
}

export function logTrackListen (artist, title, length) {
  if (!hasSegment) return

  window.analytics.track('Track listened to', {
    label: `${artist} - ${title}`,
    value: length
  })
}

export function logAddTrackFavourite (artist, title) {
  if (!hasSegment) return

  window.analytics.track('Add track to Favourites', {
    artist,
    track: title
  })
}

export function logAddTrackToCollection (artist, title) {
  if (!hasSegment) return

  window.analytics.track('Add track to Collection', {
    artist,
    track: title
  })
}

export function logShowSignupForm () {
  if (!hasSegment) return

  window.analytics.track('Show signup form')
}

export function logShowPlanSelectModal () {
  if (!hasSegment) return

  window.analytics.track('Show plan select modal')
}

export function logSignup () {
  if (!hasSegment) return

  window.analytics.track('Free user registered')
}

export function logLicenseActionClick () {
  if (!hasSegment) return

  window.analytics.track('License menu action click')
}

export function logAddPaygCartActionClick () {
  if (!hasSegment) return

  window.analytics.track('License menu: Add PAYG to cart')
}

export function logUseSubscriptionActionClick () {
  if (!hasSegment) return

  window.analytics.track('License menu: Use subscription')
}

export function logAddPaygToCart () {
  if (!hasSegment) return

  window.analytics.track('Add PAYG license to cart')
}

export function logPaygPurchase (revenue, currency, product) {
  if (!hasSegment) return

  window.analytics.track('PAYG license purchase', {
    revenue,
    currency: (currency || '').toUpperCase(),
    product,
    label: product // For Google Analytics.
  })
}

export function logSubscriptionPurchase (plan, revenue, currency) {
  if (!hasSegment) return

  window.analytics.track('Subscription purchase', {
    plan,
    revenue,
    currency: (currency || '').toUpperCase(),
    label: plan // For Google Analytics.
  })
}

export function logSubscriptionTrialPurchase (plan, revenue, currency) {
  if (!hasSegment) return

  window.analytics.track('Subscription trial purchase', {
    plan,
    revenue,
    currency: (currency || '').toUpperCase(),
    label: plan // For Google Analytics.
  })
}

export function logUserCancelledSubscription (subscription) {
  if (!hasSegment) return

  let eventName

  if (subscription.status === 'trialing') {
    eventName = 'Subscription trial set to cancel'
  } else {
    eventName = 'Subscription set to cancel'
  }

  window.analytics.track(eventName, {
    status: subscription.status,
    current_period_length: subscription.current_period_length,
    day_of_current_period: subscription.day_of_current_period,
    current_period_days_remaining: subscription.current_period_days_remaining
  })
}

export function logUserReactivatedSubscription (subscription) {
  if (!hasSegment) return

  window.analytics.track('Subscription reactivated', {
    status: subscription.status,
    current_period_length: subscription.current_period_length,
    day_of_current_period: subscription.day_of_current_period,
    current_period_days_remaining: subscription.current_period_days_remaining
  })
}

export function logSubscriptionDownload (artist, title) {
  if (!hasSegment) return

  window.analytics.track('Subscription download', {
    artist,
    track: title
  })
}

export function logSearchParameterSet (param) {
  if (!hasSegment) return

  window.analytics.track('Search parameter set', {
    label: param
  })
}

export function logClearSearch () {
  if (!hasSegment) return

  window.analytics.track('Search parameters cleared')
}

export function logSearchBarArtistSelected (artist) {
  if (!hasSegment) return

  window.analytics.track('Search bar artist selected', {
    label: artist
  })
}

export function logSimilarSongsClick (source) {
  if (!hasSegment) return

  window.analytics.track('Similar songs icon clicked', {
    source
  })
}

export function logPlanUpgradeRequested () {
  if (!hasSegment) return

  window.analytics.track('User requested plan upgrade')
}
